import React, { useState } from "react";


export default function DownloadPage() {
  const WIN_RELEASE_URL = 'https://assets.tabdsl.com/release/windows/TabDSL-Personal-win-x64.exe';
  
  // 弹窗状态：null 表示关闭，'chrome' | 'edge' | 'generic' 表示打开对应浏览器的提示
  const [modalType, setModalType] = useState<'chrome' | 'edge' | 'generic' | null>(null);

  const handleWindowsClick = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes('edg')) {
      setModalType('edge');
    } else if (userAgent.includes('chrome')) {
      setModalType('chrome');
    } else {
      setModalType('generic');
    }
  };

  const executeDownload = () => {
    setModalType(null);
    const link = document.createElement('a');
    link.href = WIN_RELEASE_URL;
    link.setAttribute('download', ''); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 3. 核心修改：在步骤中直接嵌入图片
  const getModalContent = () => {
    // 图片通用样式：自适应宽度、带微弱圆角和边框
    const imgStyle = {
      width: '100%',
      height: 'auto',
      borderRadius: '6px',
      border: '1px solid #e0e0e0',
      marginTop: '10px',
      marginBottom: '10px'
    };

    switch (modalType) {
      case 'edge':
        return {
          title: "Microsoft Edge Download Guide",
          steps: (
            <>
              <p style={{ fontSize: '13px', color: '#666', margin: '0 0 12px 0', paddingBottom: '8px', borderBottom: '1px solid #eee' }}>
                  TabDSL is verified secure. Please follow the visual guide below to complete the download.
              </p>
              {/* --- 阶段一：通过浏览器的拦截（Edge Browser Barrier） --- */}
              <div style={{ marginBottom: '12px', borderBottom: '1px dashed #ddd', paddingBottom: '8px' }}>
                <span style={{ color: '#3b5283', fontWeight: 'bold' }}>Step 1: Save the File in Edge</span>
              </div>
              
              1. Click <strong>"Continue to Download"</strong> button to save the file.<br />
              2. Hover over the downloaded file, click the <strong>"..." (three dots)</strong> menu, and choose <strong>"Keep"</strong>.<br />
              <img src="/images/edge-1.jpg" alt="Edge Step 1" style={imgStyle} />
              
              3. ⚠️ <strong>CRITICAL STEP:</strong> Click directly on the dark/black <strong>"Delete"</strong> box area to expand the hidden options menu. <em>(Note: Do not click the delete action itself; clicking the container area will expand the menu).</em><br />
              <img src="/images/edge-2.jpg" alt="Edge Step 2" style={imgStyle} />
              
              4. Select <strong>"Keep anyway"</strong> from the expanded options to save the installer.<br />
              <img src="/images/edge-3.jpg" alt="Edge Step 3" style={imgStyle} />

              {/* --- Phase 2: System Verification --- */}
              <div style={{ marginTop: '20px', marginBottom: '12px', borderBottom: '1px dashed #ddd', paddingBottom: '8px' }}>
                <span style={{ color: '#3b5283', fontWeight: 'bold' }}>Step 2: Run & Install TabDSL</span>
              </div>
              
              5. Open the downloaded <code>TabDSL-Personal-win-x64.exe</code> file. When the blue Windows SmartScreen banner appears, click <strong>"More info"</strong>.<br />
              <img src="/images/smartscreen1.png" alt="SmartScreen More Info" style={imgStyle} />
              
              6. On the next screen, click the <strong>"Run anyway"</strong> button to launch the Software.<br />
              <img src="/images/smartscreen2.png" alt="SmartScreen Run Anyway" style={imgStyle} />
            </>
          )
        };
        case 'chrome':
        default:
          // Chrome, Firefox 及其他浏览器用户：直奔主题，只提示 Windows SmartScreen 安装步骤
          return {
            title: "Windows Installation Guide",            
            steps: (
              <>
                {/* --- Phase 1: Download --- */}
                <div style={{ marginBottom: '12px', borderBottom: '1px dashed #ddd', paddingBottom: '8px' }}>
                  <span style={{ color: '#3b5283', fontWeight: 'bold' }}>Step 1: Download the Software</span>
                </div>
                
                1. Click the <strong>"Continue to Download"</strong> button to save the file.<br />
                
                {/* --- Phase 2: System Installation (过渡语) --- */}
                <div style={{ marginTop: '20px', marginBottom: '12px', borderBottom: '1px dashed #ddd', paddingBottom: '8px' }}>
                  <span style={{ color: '#3b5283', fontWeight: 'bold' }}>Step 2: Run & Install TabDSL</span>
                </div>
                
                <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#555', fontStyle: 'italic' }}>
                  📌 <strong>Note:</strong> TabDSL is verified secure. However, as a newly released app, Windows SmartScreen may show a warning banner when you open the downloaded file. Please follow the steps below to proceed:
                </p>
  
                2. Open the downloaded <code>TabDSL-Personal-win-x64.exe</code> file. When the blue SmartScreen banner appears, click <strong>"More info"</strong>.<br />
                <img src="/images/smartscreen1.png" alt="SmartScreen More Info" style={imgStyle} />
                
                3. On the next screen, click the <strong>"Run anyway"</strong> button to complete the installation.<br />
                <img src="/images/smartscreen2.png" alt="SmartScreen Run Anyway" style={imgStyle} />
              </>
            )
          };
    }
  };

  const modalContent = getModalContent();

  return (
    <>
      <section className="section" id="download" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
        <h2 style={{ color:"#3b5283 !important",fontSize: 36, textAlign: "center", marginBottom: "2.5rem", fontWeight: 600 }}>
          Get TabDSL AI Personal Client
        </h2>
        
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 24, marginTop: 40, justifyContent: 'center' }}>
          <div style={cardStyle}>
            <div>
              <h3 style={cardTitleStyle}>Windows 10 / 11 (64-bit)</h3>
            </div>
            <div style={{ marginTop: "32px" }}>
              <button 
                onClick={handleWindowsClick}
                style={primaryBtnStyle}
              >
                Download for Windows (.exe)
              </button>
            </div>
          </div>
          <div style={cardStyle}>
              <div>
                <h3 style={cardTitleStyle}>macOS 10.0 or later</h3>
              </div>
              <div style={{ marginTop: "32px"}} >
                <button 
                  onClick={() => {}}
                  style={primaryBtnStyle2}
                >
                 Launching Soon 
                </button>
              </div>
          </div>
        </div>
        <p style={{ textAlign: "center", fontSize: "14px", color: "#999", marginBottom: "40px" }}>
        Multi-User & Data Engine Edition are on the way.
        </p>
      </section>

      {/* --- 弹窗遮罩层（调大了最大宽度，给图片留出空间） --- */}
      {modalType !== null && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          backdropFilter: 'blur(3px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '24px',
            borderRadius: '12px',
            maxWidth: '640px', // 从 460px 扩大到 520px，保证图片细节清晰
            width: '90%',
            maxHeight: '90vh', // 防止小屏幕手机上弹窗超出屏幕高度
            overflowY: 'auto', // 内容过多时允许弹窗内部滚动
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>            
            <div style={{ display: 'flex', gap: '12px',marginBottom:'30px' ,justifyContent: 'flex-end' }}>
              <button onClick={() => setModalType(null)} style={{ padding: '8px 16px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', color: '#555', cursor: 'pointer' }}>
                Cancel
              </button>
              <button onClick={executeDownload} style={{ padding: '8px 20px', border: 'none', borderRadius: '6px', background: '#3b5283', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>
                Continue to Download
              </button>
            </div>

            <h4 style={{ margin: '0 0 12px 0', fontSize: '18px', color: '#111', fontWeight: 600 }}>
              🛡️ {modalContent.title}
            </h4>            

            <div style={{ 
              fontSize: '14px', 
              color: '#333', 
              lineHeight: '1.6', 
              margin: '0 0 20px 0',
              backgroundColor: '#f8f9fa',
              padding: '14px',
              borderRadius: '8px',
              borderLeft: '4px solid #3b5283'
            }}>
              {modalContent.steps}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
const cardStyle: React.CSSProperties = {
  background: "#fff",
  border: "1px solid #eef1f5",
  borderRadius: "24px",
  padding: "48px 40px",
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.015)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
};

const cardTitleStyle: React.CSSProperties = {
  fontSize: "28px",
  textAlign:"center",
  fontWeight: 700,
  color: "#444444",
  marginBottom: "4px"
};
const primaryBtnStyle: React.CSSProperties = {
  background: "#6366f1",
  color: "#fff",
  border: "none",
  padding: "16px 28px",
  borderRadius: "14px",
  fontSize: "16px",
  fontWeight: 600,
  cursor: "pointer",
  width: "100%",
  transition: "background-color 0.2s ease",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
};
const primaryBtnStyle2: React.CSSProperties = {
  background: "grey",
  color: "#fff",
  border: "none",
  padding: "16px 28px",
  borderRadius: "14px",
  fontSize: "16px",
  fontWeight: 600,
  width: "100%",
  transition: "background-color 0.2s ease",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
};
